import job from "./enterprise/job";

export default {

	state: {
		...job.state,
	},
	mutations: {
		...job.mutations,
	},
	actions: {
		...job.actions,
	},
	getters: {
		...job.getters,
	}
}



// WEBPACK FOOTER //
// ./src/storage/modules/enterprise_module.js